module.exports = __webpack_public_path__ + "static/profile-500acabcd14fec504a0f69003d0dcd66.png";